export const tokens = {
  colors: {
    primary: '#70AE42',
    secondary: '#36404B',
    error: '#D9534F',
    info: '#2196F3',
    success: '#5CB85C',
    warning: '#F0AD4E',
    gray: '#6B7280',
    yellow: '#FBBF24',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  typography: {
    fontSizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.25rem',
      xl: '1.5rem',
    },
    fontWeights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  // ... other design tokens
} 